import React, { Component } from "react";
import evio from "../../styles/images/evio.svg";
import Hyundai from "../../styles/images/brands/hyundai.svg";
import ACP from "../../styles/images/brands/acp.svg";
import error from "../../styles/images/error.svg";
import "../../styles/components/notifications/Notifications.css";
import "../../styles/components/notifications/Checkbox.scss";
import { connect } from "react-redux";
import axios from "axios";
import { Translate } from "react-redux-i18n";

class ChangeEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRequestResult: false,
      requestResult: true,
      accountAlreadyActivated: false,
      clientName: "Evio",
      loading: true,
      tryAgain: false,
    };
  }

  componentDidMount() {
    const currentUrl = window.location.pathname;
    const pathSegments = currentUrl.split("/");
    const hash = pathSegments[pathSegments.length - 1];

    this.setState({
      hash: hash,
      loading: true,
    });

    this.getData(hash);
  }
  

  getData(hash) {
    axios
      .patch(`/evioapi/users/confirmChangeEmail`, {
        hash: hash,
      })
      .then((res) => {
        // Normal success
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }

        if (this.state.clientName === "Hyundai") {
          link.href = Hyundai;
        }

        if (this.state.clientName === "ACP") {
          link.href = ACP;
        }

        if (this.state.clientName === "EVIO") {
          link.href = evio;
        }

        if (res.status === 202) {
          this.setState({
            accountAlreadyActivated: true,
            loading: false,
          });
          return;
        }

        this.setState({
          requestResult: true,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          requestResult: false,
          loading: false,
        });
      });
  }

  selectImage() {
    const clientName = this.state.clientName;
    const images = { Hyundai: Hyundai, ACP: ACP, EVIO: evio };
    return images[clientName] || evio;
  }

  render() {
    return (
      <div className="notifications-container change-email-page">
        <div className="notifications-wrapper updateResultWrapper">
          {this.state.loading ? (
            <div className="loaderDiv">
              <div className="loader"></div>
            </div>
          ) : (
            <div>
              <div className="minWidth40rem">
                <div className="centerAlignment">
                  <img
                    src={this.selectImage()}
                    alt={this.state.clientName}
                    className="evio-img"
                  />
                </div>

                <div className="resultsLayout">
                  <h2 className="pt3rem">
                    <b>
                      {this.state.accountAlreadyActivated ? (
                        <Translate value="accountAlreadyActivatedHeader" />
                      ) : this.state.requestResult ? (
                        <Translate value="emailChangeSuccessHeader" />
                      ) : (
                        <Translate value="retry" />
                      )}
                    </b>
                  </h2>

                  {!this.state.requestResult &&
                    !this.state.accountAlreadyActivated && (
                      <img src={error} alt="" className="warning-icon" />
                    )}
                </div>

                <h6>
                  {this.state.accountAlreadyActivated ? (
                    <Translate value="accountAlreadyActivated" />
                  ) : this.state.requestResult ? (
                    <Translate value="emailChangeSuccess" />
                  ) : (
                    <Translate value="emailChangeFailure" />
                  )}
                </h6>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, {})(ChangeEmail);
